import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Form as FoundationsForm } from 'foundations-components/transitional/components/Form';
import { ApolloError } from '@apollo/client';
import { getEnv } from '../../../utils/utils';
import { Form } from 'react-final-form';
import { notEmptyString, required } from '../../../utils/validation';
import { FinalFormField } from '../../../components/FinalForm';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { Link } from 'foundations-components/transitional/components/Link';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValidationError = ({
  error
}) => {
  if (!error) return null;
  const isApolloError = error instanceof ApolloError;
  if (!isApolloError && error.status === 400 && ['local', 'qa'].includes(getEnv())) {
    const json = error.responseJSON;
    console.warn('Unhandled validation error', json.message);
    return /*#__PURE__*/_jsx(Alert, {
      marginBlockEnd: "300",
      titleText: "Unhandled validation error",
      type: "warning",
      children: "See console for more information"
    });
  }
  return /*#__PURE__*/_jsxs(Alert, {
    marginBlockEnd: "300",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.somethingsGoneWrong"
    }),
    type: "danger",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.refreshPage"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyErrors.badRequest.keepsHappening"
    })]
  });
};
export const PlaylistForm = ({
  initialValues,
  onSubmit,
  onCancel,
  loading,
  error,
  submitButtonText,
  title,
  formLoadedMarker,
  closePath,
  onRequestClose
}) => {
  const closeHref = closePath !== null && closePath !== void 0 ? closePath : '/';
  const handleRequestClose = () => {
    onCancel();
    onRequestClose === null || onRequestClose === void 0 || onRequestClose();
  };
  const submit = values => {
    onSubmit(Object.assign({}, values, {
      description: values.description || ''
    }));
  };
  return /*#__PURE__*/_jsx(Modal, {
    "data-test-id": "playlist-form",
    children: /*#__PURE__*/_jsx(Form, {
      initialValues: initialValues,
      onSubmit: submit,
      render: ({
        handleSubmit
      }) => /*#__PURE__*/_jsxs(FoundationsForm, {
        onSubmit: e => {
          void handleSubmit(e);
        },
        children: [formLoadedMarker, /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(DialogHeader, {
            children: /*#__PURE__*/_jsxs(TFlex, {
              alignItems: "center",
              justifyContent: "space-between",
              children: [/*#__PURE__*/_jsx(H2, {
                marginBlockEnd: "0",
                children: title
              }), /*#__PURE__*/_jsx(View, {
                as: "span",
                marginInlineEnd: "-400",
                children: onRequestClose ? /*#__PURE__*/_jsx(Button, {
                  "aria-label": I18n.text('learningCenter.common.close'),
                  onClick: handleRequestClose,
                  use: "transparent",
                  children: /*#__PURE__*/_jsx(RemoveIcon, {
                    color: "icon-interactive-on-fill-default",
                    size: "300"
                  })
                }) : /*#__PURE__*/_jsx(UIRouterButton, {
                  "aria-label": I18n.text('learningCenter.common.close'),
                  onClick: onCancel,
                  to: closeHref,
                  use: "transparent",
                  children: /*#__PURE__*/_jsx(RemoveIcon, {
                    color: "icon-interactive-on-fill-default",
                    size: "300"
                  })
                })
              })]
            })
          }), /*#__PURE__*/_jsxs(DialogBody, {
            children: [/*#__PURE__*/_jsx(ValidationError, {
              error: error
            }), /*#__PURE__*/_jsx(FinalFormField, {
              fieldProps: {
                name: 'name'
              },
              formControlProps: {
                label: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.playlists.playlistName"
                })
              },
              render: input => /*#__PURE__*/_jsx(TextInput, Object.assign({}, input, {
                type: "text"
              })),
              validators: [required, notEmptyString]
            }), /*#__PURE__*/_jsx(FinalFormField, {
              fieldProps: {
                name: 'description'
              },
              formControlProps: {
                label: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.playlists.playlistDescription"
                }),
                help: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.common.optional"
                })
              },
              render: input => /*#__PURE__*/_jsx(TextArea, Object.assign({}, input))
            }), /*#__PURE__*/_jsx(Alert, {
              marginBlockStart: "400",
              type: "warning",
              children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                elements: {
                  Link
                },
                message: "learningCenter.playlists.acceptableUseDisclaimer_jsx",
                options: {
                  href: 'https://legal.hubspot.com/acceptable-use',
                  target: '_blank'
                }
              })
            })]
          }), /*#__PURE__*/_jsxs(DialogFooter, {
            children: [/*#__PURE__*/_jsx(Button, {
              "data-test-id": "create-button",
              disabled: loading,
              type: "submit",
              use: "primary",
              children: submitButtonText
            }), onRequestClose ? /*#__PURE__*/_jsx(Button, {
              "data-test-id": "cancel-button",
              disabled: loading,
              onClick: handleRequestClose,
              use: "secondary",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.common.cancel"
              })
            }) : /*#__PURE__*/_jsx(UIRouterButton, {
              "data-test-id": "cancel-button",
              disabled: loading,
              onClick: onCancel,
              to: closeHref,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.common.cancel"
              })
            })]
          })]
        })]
      })
    })
  });
};